import React, { memo } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import styled from 'styled-components';

const CloseIcon = ({ width = 30, height = 30 }) => (
  <CloseSvg width={width} height={height} viewBox="0 0 10 10">
    <path
      d="M2.17161 0.757355L0.757385 2.17156L3.58582 4.99999L0.757385 7.82839L2.17161 9.2426L5.00003 6.41421L7.82846 9.2426L9.2427 7.82839L6.41425 4.99999L9.2427 2.17156L7.82846 0.757355L5.00003 3.58578L2.17161 0.757355Z"
    />
  </CloseSvg>
);

CloseIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

const CloseSvg = styled.svg`
  fill: ${(props) => props.theme.main.iconDefault};
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export default memo(CloseIcon);
